import { Component, OnInit } from '@angular/core';
import { EventService, Event } from '../event.service';

@Component({
  selector: 'app-inplay',
  templateUrl: './inplay.component.html',
  styleUrls: ['./inplay.component.scss']
})
export class InplayComponent implements OnInit {
  selectedTab: 'inPlay' | 'today' | 'tomorrow' = 'inPlay';
  eventsBySport: { [sportId: string]: Event[] } = {};
  sportIds: string[] = [];

  constructor(private eventService: EventService) {}

  ngOnInit(): void {
    this.loadEvents();
  }

  loadEvents(): void {
    this.eventService.getAllEvents().subscribe(events => {
      // Group events by sportId
      const grouped: { [key: string]: Event[] } = {};
      events.forEach(event => {
        if (!grouped[event.sportId]) grouped[event.sportId] = [];
        grouped[event.sportId].push(event);
      });
      this.eventsBySport = grouped;
      this.sportIds = Object.keys(grouped);
      this.filterEvents();
    });
  }

  filterEvents(): void {
    // Implement filtering based on selectedTab (e.g., by date)
    // For now, just keep the grouped data as is
  }

  selectTab(tab: 'inPlay' | 'today' | 'tomorrow'): void {
    this.selectedTab = tab;
    this.filterEvents();
  }

  goToMarket(event: Event): void {
    // Navigate to market details – adjust route as needed
    console.log('Navigate to market', event);
    // this.router.navigate(['/fullMarket', event.sportId, event.eventId]);
  }
}